import { forwardRef } from 'react'

import { cn } from '@/common/lib/cn/cn'
import './tab.css'

export type TabProps = {
    children: React.ReactNode
    className?: string
    underlineIndicator?: React.ReactNode
} & React.HTMLAttributes<HTMLDivElement>

export const Tab = ({ children, className, underlineIndicator, ...props }: TabProps) => {
    return (
        <div className='border-b border-[#605d65] mb-6'>
            <div className='flex items-center' role='tablist'>
                <div className={cn('tab2', 'flex-1', className)} {...props}>
                    {children}
                    {underlineIndicator}
                </div>
            </div>
        </div>
    )
}

export type TabItemProps = {
    children: React.ReactNode
    className?: string
} & React.HTMLAttributes<HTMLDivElement>

export const TabItem = forwardRef<HTMLDivElement, TabItemProps>(function TabItem(
    { children, className, ...props },
    ref
) {
    return (
        <div ref={ref} className={cn('tab2-item', 'flex-1', className)} {...props}>
            {children}
        </div>
    )
})
